import { useInstance } from '../../support/ioc/useInstance';
import { useSubscription } from '@autopylot-internal/state';
import { DrawerState } from './DrawerState.ts';
import { LocateMeButton } from '../../map/location/LocateMeButton.tsx';
import { ZoomInButton } from '../../map/components/ZoomInButton.tsx';
import { ZoomOutButton } from '../../map/components/ZoomOutButton.tsx';
import { ToggleLayersControlsButton } from '../../map/toggle-layers/ToggleLayersControlsButton.tsx';
import { useBreakpoints } from '../../support/hooks/useBreakpoints.tsx';
import { CSSProperties } from 'react';
import { ToggleRadiusShape } from '../../map/components/ToggleRadiusShape.tsx';
import { useIsNative } from '../../support/hooks/useIsNative.tsx';
import { WindyMapButton } from '../../weather/windy/WindyMapButton.tsx';

export const AttachedControls: React.FC = () => {

    const drawerState = useInstance(DrawerState);
    useSubscription(() => drawerState);

    const { isLargerScreen } = useBreakpoints();
    const sideDrawer = isLargerScreen;

    const isNative = useIsNative();

    let style: CSSProperties = {};

    if (sideDrawer) {
        style = {
            position: 'fixed',
            height: 0,
            bottom: isNative ? 20 : 80, // make room for intercom launcher on web
            right: 17,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            textAlign: 'center'
        };
    } else {
        style = {
            position: 'absolute',
            height: 0,
            top: -4,
            right: 5,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            textAlign: 'center'
        };
    }

    // TODO: remove coupling to map by providing buttons in drawer prop
    return (
        <div style={style}>
            <LocateMeButton />
            <ToggleRadiusShape />
            <ToggleLayersControlsButton />
            <WindyMapButton />
            {isLargerScreen &&
                <>
                    <ZoomInButton />
                    <ZoomOutButton />
                </>
            }
        </div>
    );
};
